"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCopy = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _common = require("b2b-components/theme/common");
var TOOLTIP_MESSAGE_DURATION = 2500;
var useCopy = function useCopy(config) {
  var value = config.value,
    isAutoClear = config.isAutoClear,
    _config$autoClearAfte = config.autoClearAfterTime,
    autoClearAfterTime = _config$autoClearAfte === void 0 ? TOOLTIP_MESSAGE_DURATION : _config$autoClearAfte;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    copyStatus = _useState2[0],
    setCopyStatus = _useState2[1];
  var resetCopyStatus = (0, _react.useCallback)(function () {
    setCopyStatus(null);
  }, [setCopyStatus]);
  var handleCopyBySelect = (0, _react.useCallback)(function () {
    var body = document.body;
    if (body) {
      var input = document.createElement('input');
      input.value = value;
      input.style.display = 'none';
      body.appendChild(input);
      input.select();
      var isCopied = document.execCommand('copy');
      body.removeChild(input);
      if (!isCopied) {
        throw new Error('Copy has failed');
      }
    } else {
      throw new Error('Cannot access document body');
    }
  }, [value]);
  var handleCopy = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!navigator.clipboard) {
            _context.next = 6;
            break;
          }
          _context.next = 4;
          return navigator.clipboard.writeText(value);
        case 4:
          _context.next = 7;
          break;
        case 6:
          handleCopyBySelect();
        case 7:
          setCopyStatus(_common.COPY_STATUS.success);
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          setCopyStatus(_common.COPY_STATUS.failure);
        case 13:
          _context.prev = 13;
          if (isAutoClear) {
            setTimeout(resetCopyStatus, autoClearAfterTime);
          }
          return _context.finish(13);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10, 13, 16]]);
  })), [value, handleCopyBySelect, isAutoClear, resetCopyStatus, autoClearAfterTime]);
  return [copyStatus, handleCopy, resetCopyStatus];
};
exports.useCopy = useCopy;